import { render, staticRenderFns } from "./CourseTree.vue?vue&type=template&id=35d7120d&scoped=true&"
import script from "./CourseTree.vue?vue&type=script&lang=js&"
export * from "./CourseTree.vue?vue&type=script&lang=js&"
import style0 from "./CourseTree.vue?vue&type=style&index=0&id=35d7120d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d7120d",
  null
  
)

export default component.exports